export default {
  // 查询cad资源列表
  selectYhCadResourcesByList: '/business/jgCad/selectYhCadResourcesByList',
  // 查询cad区域列表
  selectYhCadAreaByList: '/business/jgCad/selectYhCadAreaByList',
  // 查询cad比对
  selectYhCadContrastByList: '/business/jgCad/selectYhCadContrastByList',
  selectYhCadResourcesLayerByList: '/business/jgCad/selectYhCadResourcesLayerByList',
  selectYhCadResourcesNameByList: '/business/jgCad/selectYhCadResourcesNameByList'
}
